var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"container-card"},[_c('el-col',[_c('Tracks')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }